import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postNullify = (params) => {
    return axios.post(`${backendHost}/api/admin/jackpot/nullify/update`, params);
};

export {
    postNullify
}